module.exports = __webpack_public_path__ + "static/scientific-f7e7f6524357a80dc6485104ed928698.png";